import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';

export const useNoParcelsFoundPanelCopy = () => {
  const { t, isLoggedIn } = useGlobalState();
  const { get: getAnonymous, isReady: isAnonymousReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const { get: getSignedIn, isReady: isSignedInReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const fallback = {
    title: t(MasterTranslation.IndividualCardTitle),
    subtitle: t(MasterTranslation.IndividualCardSubtitle),
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const get = isLoggedIn ? getSignedIn : getAnonymous;

  return {
    title: get('individual_card_title', fallback.title),
    subtitle: get('individual_card_subtitle', fallback.subtitle),
  };
};
